import _ from "lodash";
import React, { PureComponent } from "react";
import classes from "./ResourceCardV1.scss";
import { convertDurationToString, onEnterOrSpaceKeyDown } from "Utils";
import ResourceImagePlaceHolder from "UIComponents/ResourceImagePlaceHolder";
import I18nHOC from "UIComponents/I18nHOC";
import classNames from "classnames";
import { compose } from "lib/apolloClient";
import { connect } from "react-redux";
import { getCurrentAssessmentTypes } from "Platform/modules/PlatformModule";
import { getFormattedUserName } from "Utils/GetFormattedUserName";

class ResourceCardV1 extends PureComponent {
  onCardClick = e => {
    const { onContainerClick, isDisabled } = this.props;
    if (!isDisabled && onContainerClick) {
      e.stopPropagation();
      onContainerClick();
    }
  };
  render() {
    const {
      item,
      index,
      theme,
      rightComponent,
      imageThumbSize,
      onContainerClick,
      isDisabled,
      showTypeLabel,
      customSubTitle,
      customImageElement,
      t,
      isToddleLibrary,
      getCurrentAssessmentTypes,
      testId,
    } = this.props;
    const currentAssessmentTypes = getCurrentAssessmentTypes();
    const key = item.id;
    const typeKey = item.assessmentType?.value || "le";
    const { color, localeLabel = "", label = "" } =
      currentAssessmentTypes[typeKey] ?? {};

    const title = _.isEmpty(item.title?.value)
      ? t("common:untitled")
      : item.title.value;
    const { createdBy } = item;

    const sectionItemStyle = classNames(
      { [classes.sectionItem]: true },
      { [classes.containerDisable]: isDisabled }
    );

    return (
      <div
        key={key}
        className={sectionItemStyle}
        style={theme.sectionItem}
        onClick={this.onCardClick}
        onKeyDown={e => {
          onEnterOrSpaceKeyDown(e, this.onCardClick);
        }}
        tabIndex={0}
        data-test-id={`${testId}-${key}-card`}
      >
        <div className={classes.imageContainer} style={theme.imageContainer}>
          {customImageElement ? (
            customImageElement
          ) : (
            <ResourceImagePlaceHolder
              id={item.id}
              type={item.assessmentType}
              imageUrl={_.get(item, "image.value", "")}
              imageThumbSize={imageThumbSize}
              containerStyle={theme.imageThumbnail}
            />
          )}
        </div>
        <div
          className={classes.sectionItemDetails}
          style={theme.sectionItemDetails}
        >
          {!!showTypeLabel && (
            <div
              className={classes.sectionItemType}
              style={{ color: `${color}`, ...theme.sectionItemType }}
            >
              {`${index + 1}# ${localeLabel ? t(localeLabel) : label}`}
            </div>
          )}
          {title ? (
            <div
              className={classes.sectionLabel}
              style={theme.sectionLabel}
            >{`${title}`}</div>
          ) : null}
          <div
            className={classes.sectionAuthorAndDuration}
            style={theme.sectionAuthorAndDuration}
          >
            {createdBy && !isToddleLibrary ? (
              <span>
                {t("common:by_with_label", {
                  label: getFormattedUserName({ user: createdBy }),
                })}
              </span>
            ) : null}
            {_.get(item, "duration.value", "") ? (
              <span>
                &nbsp;&nbsp;|&nbsp;&nbsp;
                {`${convertDurationToString(
                  _.get(item, "duration.value", "")
                )}`}
              </span>
            ) : null}
            {customSubTitle ? customSubTitle : null}
          </div>
        </div>
        {rightComponent ? (
          <div className={classes.rightContainer} style={theme.rightContainer}>
            {rightComponent}
          </div>
        ) : null}
      </div>
    );
  }
}

ResourceCardV1.defaultProps = {
  theme: {
    sectionItem: {},
    rightContainer: {},
    imageContainer: {},
    sectionItemType: {},
    sectionLabel: {},
    sectionAuthorAndDuration: {},
    sectionItemDetails: {},
  },
  showTypeLabel: true,
  customSubTitle: false,
  customImageElement: null,
  testId: "appComponents-resourceCard",
};

const mapActionCreators = { getCurrentAssessmentTypes };

export default compose(
  I18nHOC({ resource: ["unitPlan", "common"] }),
  connect(null, mapActionCreators)
)(ResourceCardV1);
